import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Ariakit from '@ariakit/react';
import { cloneElement, forwardRef, useMemo } from 'react';
import styled from 'styled-components';
import { Dialog } from '../';
import { LmfAnalyticsProvider, useLmfAnalyticsOnOpen } from '../../Analytics/LmfAnalyticsProvider';
import * as Styles from './styles';
const FallbackContent = styled.div `
  flex-grow: 1;
  flex-shrink: 0;
`;
export const Drawer = forwardRef(function Drawer({ children, analyticsTitle, dir = 'ltr', backdrop = _jsx(Dialog.Backdrop, {}), header = _jsx(Dialog.Header, {}), content = _jsx(Dialog.Content, {}), ...rest }, ref) {
    const dialogContext = Ariakit.useDialogContext();
    const dialogState = Ariakit.useStoreState(dialogContext);
    useLmfAnalyticsOnOpen({
        isOpen: dialogState?.open,
        element: 'dialog',
        variant: 'modal',
        label: analyticsTitle,
    });
    content = useMemo(() => {
        return content ?? _jsx(FallbackContent, {});
    }, [content]);
    return (_jsx(LmfAnalyticsProvider, { title: analyticsTitle, children: _jsxs(Styles.Drawer, { backdrop: backdrop, "$dir": dir, ...rest, ref: ref, children: [header, content ? cloneElement(content, { children }) : children] }) }));
});
//# sourceMappingURL=index.js.map